<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="CollegeDataForm ">
        <div class="col-lg-12 col-md-12"> 
                <div class="card-body"> 
                     
                    <div class="bc d-flex align-items-center pl-3" *ngIf="submitButton">
                        <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-40px pb-2">
                        <div class="ml-2">
                          <h3 class="main-content-label mb-1"><b>
                            {{ 'header.college-data.titleList.College' | translate }}
                          </b></h3>
                           <p class="text-muted card-sub-title mb-0">
                            {{ 'header.college-data.titleList.AddNewCollegeRecord' | translate }}
                          </p>
                        </div>
                      </div>
                      <div class="bc d-flex align-items-center pl-3" *ngIf="editButton">
                        <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-40px pb-2">
                        <div class="ml-2">
                          <h3 class="main-content-label mb-1"><b>
                            {{ 'header.college-data.titleList.College' | translate }}
                          </b></h3>
                          <p class="text-muted card-sub-title mb-0">
                            {{'header.college-data.titleList.UpdateSelectedCollegeInformation' |
                            translate}}
                          </p>
                        </div>
                      </div>
                      <div class="bc d-flex align-items-center pl-3" *ngIf="deleteButton">
                        <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-40px pb-2">
                        <div class="ml-2">
                          <h3 class="main-content-label mb-1"><b>
                            {{ 'header.college-data.titleList.College' | translate }}
                          </b></h3>
                          <p class="text-muted card-sub-title mb-0">
                            {{'header.college-data.titleList.DeleteSelectedCollegeInformation' |
                            translate}}
                          </p> 
                        </div>
                      </div>
                    <hr> 
                    <div class="row mt-3 clearfix">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width" >
                                        <mat-label> {{'header.college-data.titleList.CollegeCode' | translate }} </mat-label> 
                                            <input appUppercase
                                            onkeydown="return (event.keyCode!=13);" class="color"
                                            maxlength="5" type="text" placeholder="College Code"
                                            formControlName="CgCode" matInput required
                                            [readonly]="isReadonly || isReadonlyDelete">
                                            <mat-error class="margin_tp"
                                        *ngIf="CollegeDataForm.controls['CgCode'].touched && CollegeDataForm.controls['CgCode'].errors?.required">
                                        Mandatory </mat-error>
                                    <mat-error class="margin_tp"
                                        *ngIf="CollegeDataForm.controls['CgCode'].touched && CollegeDataForm.controls['CgCode'].errors?.pattern">
                                        Invalid </mat-error>
                                    <mat-error class="margin_tp"
                                        *ngIf="CollegeDataForm.controls['CgCode'].touched && CollegeDataForm.controls['CgCode'].errors?.maxlength">
                                        Enter maximum 5 digit code
                                    </mat-error>
                                    </mat-form-field>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-5">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width" >
                                        <mat-label> {{'header.college-data.titleList.CollegeShName' | translate }} </mat-label> 
                                            <input  onkeydown="return (event.keyCode!=13);" class="color"
                                            maxlength="20" type="text"
                                            placeholder="College Short Name"
                                            formControlName="CgShName" [readonly]="isReadonlyDelete"
                                            matInput required>
                                            <mat-error class="margin_tp"
                                        *ngIf="CollegeDataForm.controls['CgShName'].touched && CollegeDataForm.controls['CgShName'].errors?.required">
                                        Mandatory </mat-error>
                                    </mat-form-field>
                                    
                                   
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4" *ngIf="CgTypeBoolean">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width" >
                                        <mat-label> {{'header.college-data.titleList.Type' | translate }} </mat-label>
                                        <mat-select [disabled]="isReadonlyDelete"
                                            onkeydown="return (event.keyCode!=13);"
                                            placeholder="CoPattern" class="colorblack"
                                            formControlName="CgType">
                                            <mat-select-filter *ngIf="select333.focused"
                                                [placeholder]="'Filter'" [displayMember]="'CgType'"
                                                [array]="typelist"
                                                (filteredReturn)="filteredListTypeList =$event">
                                            </mat-select-filter>
                                            <mat-option *ngFor="let item of filteredListTypeList"
                                                [value]="item.CdCode"> {{item.CdDesc}} </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                   
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-8">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width" >
                                        <mat-label> {{'header.college-data.titleList.CollegeName' |translate }} </mat-label>
                                         <input appCamelcase 
                                            onkeydown="return (event.keyCode!=13);" class="color"
                                            maxlength="120" type="text" placeholder="College Name"
                                            formControlName="CgName" [readonly]="isReadonlyDelete"
                                            matInput required>
                                            <mat-error class="margin_tp"
                                        *ngIf="CollegeDataForm.controls['CgName'].touched && CollegeDataForm.controls['CgName'].errors?.required">
                                        Mandatory </mat-error>
                                    </mat-form-field>
                                    
                                    
                                </div>
                            </div>
                        </div>
                        <!-- <div *ngFor="let collegedata of collegedataList;"> -->
                        <div class="col-sm-4 pr-0" >
                                <div class="form-group">
                                        <mat-card-content *ngFor="let record of dynamicrecords;" class="line-height3">
                                            <mat-checkbox *ngIf="record['FormVisible'] == true && record['FormControlName'] == 'CgS1Cent'"  [disabled]="isReadonlyDelete"
                                                onkeydown="return (event.keyCode!=13);"
                                                class="example-margin mt-2" formControlName="CgS1Cent">
                                                {{'header.college-data.titleList.Center' |translate }}   </mat-checkbox>
                                        </mat-card-content>
                                      
                                        <mat-card-content *ngFor="let record of dynamicrecords;" class="line-height3" style="float:right;">
                                            <mat-checkbox *ngIf="record['FormVisible'] == true && record['FormControlName'] == 'CgOnlyCent'"  [disabled]="isReadonlyDelete"
                                                onkeydown="return (event.keyCode!=13);"
                                                class="example-margin" formControlName="CgOnlyCent">{{'header.college-data.titleList.OnlyCenter' |translate }}</mat-checkbox>
                                        </mat-card-content>
                                        
                                </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width" >
                                        <mat-label>
                                            {{'header.college-data.titleList.CollegeAddress1' |translate }}
                                        </mat-label>
                                        <input onkeydown="return (event.keyCode!=13);" class="color" maxlength="30" type="text"
                                            placeholder="Address 1"
                                            [readonly]="isReadonlyDelete" formControlName="CgAddr1"
                                            matInput required>
                                            <mat-error class="margin_tp"
                                            *ngIf="CollegeDataForm.controls['CgAddr1'].touched && CollegeDataForm.controls['CgAddr1'].errors?.required">
                                            Mandatory </mat-error>
                                    </mat-form-field>
                                   
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width" >
                                        <mat-label>
                                            {{'header.college-data.titleList.CollegeAddress2' | translate }}
                                        </mat-label>
                                        <input onkeydown="return (event.keyCode!=13);" class="color" maxlength="30" type="text"
                                            placeholder="Address 2"
                                            [readonly]="isReadonlyDelete" formControlName="CgAddr2"
                                            matInput required>
                                            <mat-error class="margin_tp"
                                        *ngIf="CollegeDataForm.controls['CgAddr2'].touched && CollegeDataForm.controls['CgAddr2'].errors?.required">
                                        Mandatory </mat-error>
                                    </mat-form-field>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width" >
                                        <mat-label>
                                            {{'header.college-data.titleList.CollegeAddress3' | translate }}
                                        </mat-label>
                                        <input onkeydown="return (event.keyCode!=13);" class="color" type="text"
                                            placeholder="Address 3"
                                            [readonly]="isReadonlyDelete" formControlName="CgAddr3" maxlength="30"
                                            matInput>
                                    </mat-form-field>
                                   
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width" >
                                        <mat-label> {{'header.district-data.table.District' | translate }} </mat-label>
                                        <mat-select formControlName="DsCode"
                                            onkeydown="return (event.keyCode!=13);" #select333
                                            required placeholder="CoPattern" class="colorblack"
                                            [disabled]="isReadonlyDelete">
                                            <mat-select-filter *ngIf="select333.focused"
                                                [placeholder]="'Filter'" [displayMember]="'DsName'"
                                                [array]="DsCodelist"
                                                (filteredReturn)="filteredListDistCode =$event">
                                            </mat-select-filter>
                                            <mat-option *ngFor="let item of filteredListDistCode"
                                                [value]="item.DsCode" (click)="SelectTn(item.DsCode)"> {{item.DsName}} </mat-option>
                                        </mat-select>
                                        <mat-error class="margin_tp"
                                            *ngIf="CollegeDataForm.controls['DsCode'].touched && CollegeDataForm.controls['DsCode'].errors?.required">
                                            Mandatory </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4" *ngIf="TownVisible">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width" >
                                        <mat-label>{{'header.town-data.table.Town' | translate }}  </mat-label>
                                        <mat-select onkeydown="return (event.keyCode!=13);"
                                            #select330 placeholder="CoPattern"
                                            class="colorblack" [disabled]="isReadonlyDelete || districtSelect"
                                            formControlName="CgTnCode" [required] = "!districtSelect">
                                            <mat-select-filter *ngIf="select330.focused"
                                                [placeholder]="'Filter'" [displayMember]="'TnName'"
                                                [array]="tncodelist"
                                                (filteredReturn)="filteredListTownCode =$event">
                                            </mat-select-filter>
                                            <mat-option *ngFor="let item of filteredListTownCode"
                                                [value]="item.TnCode"> {{item.TnName}} </mat-option>
                                        </mat-select>
                                        <mat-error class="margin_tp"
                                        *ngIf="CollegeDataForm.controls['CgTnCode'].touched && CollegeDataForm.controls['CgTnCode'].errors?.required">
                                        Mandatory</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width" >
                                        <mat-label> {{'header.college-data.titleList.CollegePin' |translate}} </mat-label> 
                                        <input onkeydown="return (event.keyCode!=13);" class="color"
                                            type="text" placeholder="590010"
                                            [readonly]="isReadonlyDelete" formControlName="CgPin"
                                            maxlength="6" matInput required>
                                            <mat-error class="margin_tp"
                                            *ngIf="CollegeDataForm.controls['CgPin'].touched && CollegeDataForm.controls['CgPin'].errors?.required">
                                            Mandatory</mat-error>
                                        <mat-error class="margin_tp"
                                            *ngIf="CollegeDataForm.controls['CgPin'].touched && CollegeDataForm.controls['CgPin'].errors?.pattern">
                                            Invalid </mat-error>
                                        <mat-error class="margin_tp"
                                            *ngIf="CollegeDataForm.controls['CgPin'].touched && CollegeDataForm.controls['CgPin'].errors?.maxlength">
                                            Enter 6 digit pincode </mat-error>
                                        <mat-error
                                            *ngIf="CollegeDataForm.controls['CgPin'].touched && CollegeDataForm.controls['CgPin'].errors?.minlength">
                                            Enter 6 digit pincode</mat-error>
                                    </mat-form-field>
                                  
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width" >
                                        <mat-label> {{'header.college-data.titleList.CollegeWeb' |translate}} </mat-label>
                                         <input onkeydown="return (event.keyCode!=13);" class="color"
                                            maxlength="50" type="url" value="http://"
                                            placeholder="www.Collegewebsite.com"
                                            [readonly]="isReadonlyDelete" formControlName="CgWeb"
                                            matInput> 
                                               <mat-error class="margin_tp"
                                            *ngIf="CollegeDataForm.controls['CgWeb'].touched && CollegeDataForm.controls['CgWeb'].errors?.pattern">
                                            Invalid</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width" >
                                        <mat-label> {{'header.college-data.titleList.CollegeEmail' |translate }} </mat-label> 
                                            <input onkeydown="return (event.keyCode!=13);" class="color"
                                            maxlength="50" type="text" placeholder="test@test.com"
                                            [readonly]="isReadonlyDelete" formControlName="CgEmail"
                                            matInput required>
                                            <mat-error class="margin_tp"
                                        *ngIf="CollegeDataForm.controls['CgEmail'].touched && CollegeDataForm.controls['CgEmail'].errors?.required">
                                        Mandatory </mat-error>
                                    <mat-error class="margin_tp"
                                        *ngIf="CollegeDataForm.controls['CgEmail'].touched && CollegeDataForm.controls['CgEmail'].errors?.pattern || CollegeDataForm.controls['CgEmail'].errors?.email">
                                        Invalid</mat-error>
                                    </mat-form-field>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width ml-0">
                                        <mat-label class="mt-1 lclass">{{'header.college-data.titleList.CollegePhone' |translate }}</mat-label> 
                                                <input
                                            onkeydown="return (event.keyCode!=13);" class="color"
                                            type="text" maxlength="12" placeholder="Phone Number" minlength="10"
                                            [readonly]="isReadonlyDelete" formControlName="CgPhone"
                                            matInput required>
                                            <mat-error class="margin_tp"
                                            *ngIf="CollegeDataForm.controls['CgPhone'].touched && CollegeDataForm.controls['CgPhone'].errors?.required">
                                            Mandatory </mat-error>
                                        <mat-error class="margin_tp"
                                            *ngIf="CollegeDataForm.controls['CgPhone'].touched && CollegeDataForm.controls['CgPhone'].errors?.pattern">
                                            Invalid</mat-error>
                                            <mat-error class="margin_tp"
                                            *ngIf="CollegeDataForm.controls['CgPhone'].touched && CollegeDataForm.controls['CgPhone'].errors?.maxlength">
                                            Must Be Between 10 To 12 Characters </mat-error>
                                        <mat-error
                                            *ngIf="CollegeDataForm.controls['CgPhone'].touched && CollegeDataForm.controls['CgPhone'].errors?.minlength">
                                            Must Be Between 10 To 12 Characters </mat-error>
                                            
                                    </mat-form-field>
                                   
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width" >
                                        <mat-label> {{'header.college-data.titleList.CollegeFax' |translate }}</mat-label> <input
                                            onkeydown="return (event.keyCode!=13);" class="color"
                                            maxlength="12" type="text" placeholder="1045879654" minlength="9"
                                            [readonly]="isReadonlyDelete" formControlName="CgFax"
                                            matInput>
                                            <mat-error class="margin_tp"
                                            *ngIf="CollegeDataForm.controls['CgFax'].touched && CollegeDataForm.controls['CgFax'].errors?.pattern">
                                            Invalid </mat-error>
                                            <mat-error class="margin_tp"
                                            *ngIf="CollegeDataForm.controls['CgFax'].touched && CollegeDataForm.controls['CgFax'].errors?.maxlength">
                                            Must Be Between 9 To 12 Characters </mat-error>
                                        <mat-error
                                            *ngIf="CollegeDataForm.controls['CgFax'].touched && CollegeDataForm.controls['CgFax'].errors?.minlength">
                                            Must Be Between 9 To 12 Characters </mat-error>
                                    </mat-form-field>
                                   
                                </div>
                            </div> 
                        </div>  
                        <div class="row col-sm-12"> 
                            <div  class="col-sm-12 prpl">
                                <button id="Delete" type="button" *ngIf="deleteButton && ColgDelete"
                                class="btn btn-primary btn-icon-text floatright mt-1"
                                 (click)="openConformationModalBox()">
                                <span style="display: contents; align-items: center;">
                                     <img width="20vh" src="../../assets/img/trash.gif" style="margin-right: 5px;">
                                     {{'header.college-data.titleList.Delete' |translate }}
                                </span>
                                </button>
                                <button id="Update" type="button" *ngIf="editButton && ColgUpdate"
                                class="btn btn-primary btn-icon-text floatright mt-1"
                                 (click)="update()">
                                <span style="display: contents; align-items: center;">
                                     <img width="20vh" src="../../assets/img/edit1.gif" style="margin-right: 5px;">
                                     {{'header.college-data.titleList.Update' |translate }}
                                </span>
                                </button>
                                <button id="Save" type="button" *ngIf="submitButton && ColgCreate"
                                class="btn btn-primary btn-icon-text floatright mt-1"
                                 (click)="submit()">
                                <span style="display: contents; align-items: center;">
                                     <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                     {{'header.college-data.titleList.Save' |translate }}
                                </span> 
                                </button>
                                <button id="Back" type="button" [mat-dialog-close]="true"
                                class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                                <span style="display: contents; align-items: center;" >
                                     <img width="20vh"  src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                     {{'header.college-data.titleList.Back' |translate }}
                                </span>
                                </button> 
                            </div>
                                <!-- <div class="col-sm-7" *ngIf="editButton || deleteButton"></div> -->
                            
                        </div>
                    </div>
            </div>
        </div>
    </form>               
</div>
